import React from 'react';
import Backend from '../../../Layouts/Backend';
import Datagrid from '../../../UI/Datagrid';
import { withTranslation } from 'react-i18next';
import { Alert, NavButton } from '../../../UI/Common';
import { DialogBox } from '../../../UI/Modal';
import { FormGroup, CustomInput, Label } from 'reactstrap';
import { cloneDeep } from 'lodash';

class UsersPage extends React.Component {
  getUsersData = () => {
    const { users, inactiveShouldHide, lockedShouldHide } = this.props;
    let _users = cloneDeep(users);
    if (inactiveShouldHide) {
      _users = users.filter((user) => user.active === true);
    }
    if (lockedShouldHide) {
      _users = _users.filter((_user) => _user.lockStatus === false);
    }
    return _users;
  };
  render() {
    //prettier-ignore
    const { t, users, datagridProps, errors, openModal, inactiveShouldHide, lockedShouldHide } = this.props;
    let title = 'Expire Password';
    let bodyText = 'Are you sure you want to expire password?';

    switch (openModal) {
      case 2:
        title = 'Lock User';
        bodyText =
          'Locking the user will prevent them from being able to log in, but will not stop any configured notifications from being delivered. Would you like to proceed?';
        break;
      case 3:
        title = 'Unlock User';
        bodyText = 'Are you sure you want to unlock user?';
        break;
      case 4:
        title = 'Mark Active';
        bodyText =
          'Setting the user to active will allow configured notifications to be delivered. Would you like to proceed?';
        break;
      case 5:
        title = 'Mark Inactive';
        bodyText =
          'Setting the user to inactive will prevent any configured notifications from being delivered. Would you like to proceed?';
        break;
      default:
        break;
    }
    return (
      <Backend>
        <div className="content-inner">
          <Alert.Error text={errors} />
          <DialogBox
            isOpen={openModal !== 0}
            title={title}
            body={bodyText}
            onCancel={() => this.props.onCancel()}
            onYes={() => this.props.onYes()}
          />

          <div className="d-flex flex-row justify-content-between">
            <NavButton id="new-user-btn" to="/configure/users/new-user">
              <i className="md-icon">add</i>
              {t('New User')}
            </NavButton>
            <div className="d-flex flex-row align-items-end mb-10">
              <FormGroup className="mb-0">
                <CustomInput
                  type="checkbox"
                  id="hide-inactive-switch"
                  label={t('Hide Inactive')}
                  checked={inactiveShouldHide}
                  onChange={(e) => this.props.hideInactive(e)}
                />
              </FormGroup>
              <FormGroup className="ml-5">
                <CustomInput
                  type="checkbox"
                  id="hide-locked-switch"
                  label={t('Hide Locked')}
                  checked={lockedShouldHide}
                  onChange={(e) => this.props.hideLocked(e)}
                />
              </FormGroup>
            </div>
          </div>
          <Datagrid
            datagridProps={{
              keyField: 'id',
              data: this.getUsersData(),
              ...datagridProps,
            }}
            ctxMenuOptions={this.props.ctxMenuOptions}
            exportProps={{
              fileName: 'Users',
            }}
            onContext={this.props.onContext}
          />
        </div>
      </Backend>
    );
  }
}

export default withTranslation('app')(UsersPage);
